import { T } from '../domaine/libelles'
import { el, vider } from '../ui/dom'

/*
  Écran Animer — fiches d'animation embarquées dans le bundle.

  Le Markdown est converti en HTML au build (outils/plugin-fiches.ts) et
  précaché par Workbox : aucune requête réseau, jamais, y compris devant un
  groupe sur la plage à 19 h.
*/

interface Fiche {
  titre: string
  html: string
}

// Chargées à la compilation : le bundle contient déjà le HTML.
const modules = import.meta.glob<{ default: Fiche }>('../fiches/*.md', { eager: true })

const FICHES: Fiche[] = Object.keys(modules)
  .sort()
  .map((chemin) => (modules[chemin] as { default: Fiche }).default)

export function monterAnimer(hote: HTMLElement): () => void {
  let vivant = true

  function rendreListe(): void {
    if (!vivant) return
    vider(hote)

    const liste = el('div', { class: 'liste-fiches' })
    for (const fiche of FICHES) {
      const bouton = el('button', { type: 'button', class: 'option' }, [
        el('span', { class: 'option__titre', text: fiche.titre }),
      ])
      bouton.addEventListener('click', () => rendreFiche(fiche))
      liste.append(bouton)
    }

    hote.append(
      el('section', { class: 'entete-simple' }, [
        el('h1', { class: 'entete-simple__titre', text: T.animerTitre }),
        el('p', { class: 'entete-simple__aide', text: T.animerAide }),
      ]),
      liste,
    )
  }

  function rendreFiche(fiche: Fiche): void {
    if (!vivant) return
    vider(hote)

    const retour = el('button', { type: 'button', class: 'lien-retour', text: '‹ ' + T.retourFiches })
    retour.addEventListener('click', rendreListe)

    hote.append(
      el('section', { class: 'entete-simple' }, [retour]),
      // Contenu de confiance : ces fichiers sont dans le dépôt, pas saisis
      // par un utilisateur, et convertis à la compilation.
      el('article', { class: 'fiche', html: fiche.html }),
    )
    hote.scrollTop = 0
  }

  rendreListe()

  return () => {
    vivant = false
  }
}
